module.exports = __webpack_public_path__ + "img/amex_logo.ab5a988b.png";